import { FunctionComponent } from 'react';
import './contact.scss';

export type Props = { icon: () => JSX.Element; label: () => JSX.Element; link: string | undefined };

const CommunicationElement: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <div className="communication-element">
      <div className="icon">{props.icon()}</div>
      <div className="label">
        {props.link ? <a href={props.link}>{props.label()}</a> : <>{props.label()}</>}
      </div>
    </div>
  );
};

export default CommunicationElement;
